import * as commonActions from './commonActions';
import * as dashboardActions from './dashboardActions';
import * as instrumentTypes from '../constants/instrumentListConstants';
import * as dashboardTypes from '../constants/dashboardConstants';
import { getPath } from './commonActions';

import axios from 'axios';

const apiPath = getPath("api");

export const fetchDetails = () => {
  var user = JSON.parse(localStorage.getItem('user'));
  var userDetail = JSON.parse(localStorage.getItem('userDetail'));
  var platform = localStorage.getItem('platform');
  var config = {
    headers: {
      "Cache-Control": "no-cache",
      "username": user.UID,
      'sid': user.SID,
      "location": user.location,
      "platform": platform,

    }
  };
  //      "Content-Type": "application/json; charset=utf-8",

  if (user !== null) {
    return (dispatch) => {
      dispatch({ type: instrumentTypes.LOAD_ALL_INSTRUMENTS })
      return axios.get(apiPath + '' + '/user/getAllInstruments', config)
        .then(response => {
          let result = response.data;
          dispatch({ type: instrumentTypes.LOAD_ALL_INSTRUMENTS_SUCCESS, result })
        }).then(response => {
          dispatch({ type: dashboardTypes.LOAD_TEMPLIST })
          return axios.post(apiPath + '' + '/user/ScrTemplateDetail', {
            UT: "trader",
            M: "S"
          }, config)
        }).then(response => {
          let result = response.data;
          dispatch({ type: dashboardTypes.LOAD_TEMPLIST_SUCCESS, result })
        }).then(response => {
          dispatch({ type: dashboardTypes.LOAD_WIDGET })
          return axios.post(apiPath + '' + '/user/ScrTemplateDetail', {
            UT: "trader",
            M: "L"
          }, config)
        }).then(response => {
          let result = response.data;
          dispatch({ type: dashboardTypes.LOAD_WIDGET_SUCCESS, result })
        }).then(response => {
          dispatch({ type: instrumentTypes.LOAD_INSTRUMENT_LIST })
          return axios.get(apiPath + '' + '/user/instrument_list', config)
        }).then(response => {
          let result = response.data;
          dispatch({ type: instrumentTypes.LOAD_INSTRUMENT_LIST_SUCCESS, result })
        }).then(response => {
          var noMarginAccBal = userDetail.newRiskCheckType === "MT_NoMrg" || (userDetail.newRiskCheckType === "MT_AsPerAcc" && JSON.parse(localStorage.getItem("DFA")).MT === "MT_NoMrg");
          if (noMarginAccBal) {
            dispatch({ type: instrumentTypes.NO_MARGIN_LOAD })
            return axios.get(apiPath + '' + `/user/getNoMarginDetails?accCode=${JSON.parse(localStorage.getItem("DFA")).C}`, config)
              .then(response => {
                let result = response.data;
                dispatch({ type: instrumentTypes.NO_MARGIN_LOAD_SUCCESS, result })
              }).then(response => {
                dispatch(dashboardActions.loadLanguages());
                dispatch(dashboardActions.getStockCodeList());
                dispatch(commonActions.loadStkWisePairList());
                // dispatch(dashboardActions.loadBiometricDevice());
                dispatch(dashboardActions.isAllApiLoaded(true));
              }).catch(error => {
                console.log("error " + error); throw (error);
              });
          } else {
            dispatch({ type: instrumentTypes.LOAD_MARGIN })
            return axios.get(apiPath + '' + `/user/getMargin?accCode=${JSON.parse(localStorage.getItem("DFA")).C}&UT=${"trader"}&isOrders=${false}`, config)
              .then(response => {
                let result = response.data;
                dispatch({ type: instrumentTypes.LOAD_MARGIN_SUCCESS, result })
              }).then(response => {
                // dispatch(userDetail.newRiskCheckType === "MT_NoMrg" || (userDetail.newRiskCheckType === "MT_AsPerAcc" && JSON.parse(localStorage.getItem("DFA")).MT === "MT_NoMrg") ? instrumentListActions.loadNoMrgAccBalMargin(JSON.parse(localStorage.getItem("DFA")).C) : instrumentListActions.loadAccBalMargin(JSON.parse(localStorage.getItem("DFA")).C, "trader", false));
                dispatch(dashboardActions.loadLanguages());
                dispatch(dashboardActions.getStockCodeList());
                dispatch(commonActions.loadStkWisePairList());
                // dispatch(dashboardActions.loadBiometricDevice());
                dispatch(dashboardActions.isAllApiLoaded(true));
              }).catch(error => {
                console.log("error " + error); throw (error);
              });
          }
        });
    }
  }
}
